/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-02-11 14:47:58
 * @FilePath: /knit-web/src/locale/zh-CN.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import menu from './zh-CN/menu';
import workflow from './zh-CN/workflow';
import tool from './zh-CN/tool';
import common from './zh-CN/common';
import database from './zh-CN/database';
import apps from './zh-CN/apps';
import welcome from './zh-CN/welcome';
import executionHistory from './zh-CN/execution-history';
import discover from './zh-CN/discover';
import configuration from './zh-CN/configuration';
import evaluation from './zh-CN/evaluation';
import components from './zh-CN/components';
import nodeConfig from './zh-CN/node-config';
import workspaceSettings from './zh-CN/workspace-settings';
import notification from './zh-CN/notification';
import verification from './zh-CN/verification';
import document from './zh-CN/document';
import account from './zh-CN/account';
import contactUs from './zh-CN/contact-us';
import messages from './zh-CN/messages';
import knowledge from './zh-CN/knowledge';
import credit from './zh-CN/credit';
import home from './zh-CN/home';
import provider from './zh-CN/provider';

export default {
  ...menu,
  ...workflow,
  ...tool,
  ...common,
  ...database,
  ...knowledge,
  ...credit,
  ...home,
  ...apps,
  ...welcome,
  ...executionHistory,
  ...discover,
  ...configuration,
  ...evaluation,
  ...components,
  ...nodeConfig,
  ...workspaceSettings,
  ...notification,
  ...verification,
  ...document,
  ...account,
  ...contactUs,
  ...messages,
  ...provider,
  'navbar.docs': '文档',
};
